package top.wcpe.allincore.dsl.compiler.codegen.internal

/**
 * 数值字面量归一化：统一收敛到 Double。
 *
 * IR 层（M6b Wave 3 起）只承认 Double 一种数值表示，与 theme 数值表示对齐，
 * 避免下游 Evaluator / PropApplier 处理 Long/Double 双类型分支。
 * 整数字面量在 2^53 以内可精确表示；当前 DSL 不存在超出该范围的需求。
 */
internal object NumberNormalizer {

    fun normalize(v: Number): Any = v.toDouble()
}
